import { createAction } from 'redux-actions';
import * as actions from './actions';

export const fetchHostFilesConfigRequest = createAction(actions.FETCH_HOST_FILES_CONFIG_REQUEST);
export const fetchHostFilesConfigSuccess = createAction(actions.FETCH_HOST_FILES_CONFIG_SUCCESS);
export const fetchHostFilesConfigFailure = createAction(actions.FETCH_HOST_FILES_CONFIG_FAILURE);

export const fetchHostFilesRequest = createAction(actions.FETCH_HOST_FILES_REQUEST);
export const fetchHostFilesSuccess = createAction(actions.FETCH_HOST_FILES_SUCCESS);
export const fetchHostFilesFailure = createAction(actions.FETCH_HOST_FILES_FAILURE);

export const fetchHostFilesCountsRequest = createAction(actions.FETCH_HOST_FILES_COUNTS_REQUEST);
export const fetchHostFilesCountsSuccess = createAction(actions.FETCH_HOST_FILES_COUNTS_SUCCESS);
export const fetchHostFilesCountsFailure = createAction(actions.FETCH_HOST_FILES_COUNTS_FAILURE);

export const uploadHostFileRequest = createAction(actions.UPLOAD_HOST_FILE_REQUEST);
export const uploadHostFileSuccess = createAction(actions.UPLOAD_HOST_FILE_SUCCESS);
export const uploadHostFileFailure = createAction(actions.UPLOAD_HOST_FILE_FAILURE);
export const uploadHostFileProgress = createAction(actions.UPLOAD_HOST_FILE_PROGRESS);
export const uploadHostFileBatchProgress = createAction(actions.UPLOAD_HOST_FILE_BATCH_PROGRESS);

export const renameHostFileRequest = createAction(actions.RENAME_HOST_FILE_REQUEST);
export const renameHostFileSuccess = createAction(actions.RENAME_HOST_FILE_SUCCESS);
export const renameHostFileFailure = createAction(actions.RENAME_HOST_FILE_FAILURE);

export const reassignHostFileRequest = createAction(actions.REASSIGN_HOST_FILE_REQUEST);
export const reassignHostFileSuccess = createAction(actions.REASSIGN_HOST_FILE_SUCCESS);
export const reassignHostFileFailure = createAction(actions.REASSIGN_HOST_FILE_FAILURE);

export const deleteHostFileRequest = createAction(actions.DELETE_HOST_FILE_REQUEST);
export const deleteHostFileSuccess = createAction(actions.DELETE_HOST_FILE_SUCCESS);
export const deleteHostFileFailure = createAction(actions.DELETE_HOST_FILE_FAILURE);

export const viewHostFileRequest = createAction(actions.VIEW_HOST_FILE_REQUEST);
export const viewHostFileFailure = createAction(actions.VIEW_HOST_FILE_FAILURE);

export const downloadHostFileRequest = createAction(actions.DOWNLOAD_HOST_FILE_REQUEST);
export const downloadHostFileFailure = createAction(actions.DOWNLOAD_HOST_FILE_FAILURE);

export const clearHostFilesStatus = createAction(actions.CLEAR_HOST_FILES_STATUS);
